






























import {
  defineComponent, computed, watch,
} from '@vue/composition-api';
import { Popup } from '@hb/coffee';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { formatCreditAmount } from '@/views_v2/home/components/utils';
import { homeStoreActions } from '@/pages/home/store';
import store from '@/store';
import useDispatchProcess from '@/hooks/useDispatchProcess';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import { hideSkWebviewTabbarMask, showSkWebviewTabbarMask } from '@/pages/home/utils';
import {
  TP_HOME_CREDIT_AMOUNT_ALTER_POPUP_CONFIRM,
  TP_HOME_CREDIT_AMOUNT_ALTER_POPUP_CLOSE,
  TP_HOME_CREDIT_AMOUNT_ALTER_POPUP,
} from '@/pages/home/tianqi';

export default defineComponent({
  components: {
    Popup,
  },
  emits: ['closeDailog', 'showDailog'],
  setup(_, { emit }) {
    const { applyProcessDispatch } = useDispatchProcess();

    /** 额度更新-弹窗的展示状态：如，预授信出额 */
    const creditAmountAlterPopupVisible = computed(
      () => store.state.homeStore.creditAmountAlterPopupVisible,
    );
    /** 格式化后的额度 */
    const formattedCreditAmount = computed(
      () => formatCreditAmount(store.state.homeStore.creditAmountAlterPopupAmount || 0),
    );

    const closePopup = () => {
      homeStoreActions.setCreditAmountAlterPopupVisible(false);
      dialogHelper.closeDialogNotify();
    };

    /** 点击立即提现 */
    const onApplyClick = () => {
      /** 进入提现流程 */
      applyProcessDispatch();
      /** 关闭弹窗 */
      closePopup();
      /** ubt埋点 */
      ubtSetupPageButton(TP_HOME_CREDIT_AMOUNT_ALTER_POPUP_CONFIRM);
    };

    /** 点击关闭 */
    const onClose = () => {
      closePopup();
      ubtSetupPageButton(TP_HOME_CREDIT_AMOUNT_ALTER_POPUP_CLOSE);
    };

    watch(() => creditAmountAlterPopupVisible.value, (visible) => {
      if (visible) {
        ubtSetupModuleExpose(TP_HOME_CREDIT_AMOUNT_ALTER_POPUP);
        emit('showDailog');
        /** 老首页无DailogController，临时在此同步tabbar遮罩状态，TODO: 后续移除 */
        showSkWebviewTabbarMask();
      } else {
        emit('closeDailog');
        /** 老首页无DailogController，临时在此同步tabbar遮罩状态，TODO: 后续移除 */
        hideSkWebviewTabbarMask();
      }
    });

    return {
      creditAmountAlterPopupVisible,
      formattedCreditAmount,
      onApplyClick,
      onClose,
    };
  },
});
